import React from "react";

const SalesloftIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_1057)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 6,
  fill: "#06492E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.6074 13.2657C14.6074 11.8002 16.0166 10.6165 17.8203 10.6165C20.1313 10.6165 21.5404 11.6875 22.3295 17.2677H22.8368L23.5696 9.65832C18.3276 7.85462 11.9018 9.77106 11.7891 15.2385C11.7891 21.1569 21.2022 21.1569 21.2022 26.5681C21.2022 28.1463 19.7931 29.2172 18.2148 29.2172C14.0438 29.2172 13.0855 25.7226 12.8601 22.0588H12.3528L11 28.9354C11 28.9354 14.1001 30.7391 17.4257 30.7391C21.4277 30.6827 24.0769 27.7518 24.1896 24.6516C24.1896 18.7332 14.6074 17.4932 14.6074 13.2657Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.3508 28.6293C26.3508 27.502 27.2529 26.5438 28.4364 26.5438C29.6769 26.5438 30.5789 27.502 30.5789 28.6293C30.5789 29.7567 29.6769 30.7149 28.4934 30.7149C27.1966 30.7712 26.3508 29.7567 26.3508 28.6293Z",
  fill: "#B4D625"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_1057"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SalesloftIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;